oi.init({
	formSelector: document.getElementsByTagName('form'),
	errorHTML: '<span class="form-error field-validation-error" data-oi-id="{{id}}" role="alert">{{message}}</span>',
	errorClass: 'input-validation-error',
	errorPosition: 'afterend',
	errorScrollOffset: 75,
	interactedClass:'oi-has-interacted',
	watchInputs: true,
	validateHidden: false,
	onInvalid: function(input) {
		input.classList.add('input-validation-error');
	},
	onValid: function(input) {
		input.classList.remove('input-validation-error');
	}
});
